/**
 * Rola suavemente até uma seção da página atual, descontando a altura do
 * header fixo — mesmo offset usado pelo `page-transition-provider` nos links
 * com hash. Retorna `false` quando o alvo não existe na página.
 */
export function scrollToSection(id: string) {
	const target = document.getElementById(id.replace(/^#/, ""));

	if (!target) {
		return false;
	}

	const header = document.querySelector("header");
	const headerOffset = header instanceof HTMLElement ? header.offsetHeight : 0;

	window.scrollTo({
		top: Math.max(
			target.getBoundingClientRect().top + window.scrollY - headerOffset,
			0,
		),
		behavior: "smooth",
	});

	return true;
}
